import { Divider, Typography } from '@mui/material';

export function addListSeparatorLine(date: string) {
  return (
    <Divider data-qa-element-id="date_divider">
      <Typography
        variant="subtitle2"
        sx={{ backgroundColor: 'grey.300', borderRadius: 4, padding: 1, scale: 0.8, lineHeight: 1 }}
      >
        {date}
      </Typography>
    </Divider>
  );
}
